import { createSelector } from 'reselect'
import { PAYMENT_OPTIONS } from 'constants/payment'
import { floatify } from 'lib/maths/mathUtils'
import getMerchantFeeAmount from '../getMerchantFeeAmount'
import getCreditPayAmount from '../getCreditPayAmount'
import getGiftCardPayAmount from '../getGiftCardPayAmount'
import getPartnershipModifierAmount from '../getPartnershipModifierAmount'
import { getCheckoutLoyaltyBurnTotalInCurrency } from '../../loyalty/getCheckoutLoyaltyBurnTotals'
import getGroupPaymentPreviewRequestInfo from './getGroupPaymentPreviewRequestInfo'
import {
  getSavedGroupPaymentAllocation,
  getSavedGroupPaymentFingerprint,
} from './getGroupPaymentLeadContributionAmount'
import getGroupPaymentDepositAmount from './getGroupPaymentDepositAmount'

export const isGroupPaymentReadyToPay = createSelector(
  (state: App.State) => state.checkout.payment.paymentSelected === PAYMENT_OPTIONS.GROUP_PAYMENT,
  getSavedGroupPaymentAllocation,
  getSavedGroupPaymentFingerprint,
  getGroupPaymentPreviewRequestInfo,
  (isSelected, allocation, savedFingerprint, requestInfo): boolean => (
    isSelected &&
    !!allocation &&
    !!savedFingerprint &&
    !!requestInfo &&
    savedFingerprint === requestInfo.fingerprint
  ),
)

// Deposit = the lead's share plus lead-only items, so it matches svc-payment's first payment.
const getGroupPaymentDueToday = createSelector(
  getGroupPaymentDepositAmount,
  (state: App.State) => getMerchantFeeAmount(state, PAYMENT_OPTIONS.GROUP_PAYMENT),
  getCreditPayAmount,
  getGiftCardPayAmount,
  getCheckoutLoyaltyBurnTotalInCurrency,
  getPartnershipModifierAmount,
  isGroupPaymentReadyToPay,
  (
    depositAmount,
    merchantFee,
    creditAmount,
    giftCardAmount,
    loyaltyBurnTotalInCurrency,
    partnershipModifierAmount,
    isReady,
  ): number => {
    if (!isReady || !depositAmount) {
      return 0
    }

    const residual = depositAmount
      + merchantFee
      - creditAmount
      - giftCardAmount
      - loyaltyBurnTotalInCurrency
      - partnershipModifierAmount

    return floatify(Math.max(0, residual))
  },
)

export default getGroupPaymentDueToday
